import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    McfxViqContactFragment as McfxViqContact,
    GetMcfxViqContacts as GetMcfxViqContactsQuery,
    GetMcfxViqContactsVariables as GetMcfxViqContactsQueryVariables,
} from 'nutshell-graphql-types';

import GET_MCFX_VIQ_CONTACTS from '../queries/get-mcfx-viq-contacts.graphql';

export function useGetMcfxViqContacts(
    mcfxCompanyId?: string | null,
    skip: boolean = false
): {
    mcfxViqContacts: McfxViqContact[] | null | undefined;
    refetch: () => Promise<any>;
    isLoading: boolean;
    isRefetching: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading, refetch, networkStatus} = useQuery<
        GetMcfxViqContactsQuery,
        GetMcfxViqContactsQueryVariables
    >(GET_MCFX_VIQ_CONTACTS, {
        variables: {
            id: mcfxCompanyId || '',
        },
        skip: !mcfxCompanyId || skip,
        fetchPolicy: 'cache-and-network',
    });

    return {
        mcfxViqContacts: data ? data.mcfxViqContacts : undefined,
        refetch,
        isLoading: loading,
        isRefetching: networkStatus === 4,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
